<template>
  <div>
    <nav>
      <el-date-picker v-model="calendarvalue" type="month" value-format="yyyy-MM-dd" placeholder="选择月">
      </el-date-picker>
      <el-button type="primary" @click="setMethods">设置假期</el-button>
    </nav>
    <!-- 设置假期弹窗 -->
    <el-dialog title="设置假期" :visible.sync="dialogTableVisible" width="500px">
      <div class="setBox" v-if="dialogTableVisible">
        <el-form ref="form" :rules="rules" :model="setMethodsForm" label-width="180px">
          <el-form-item label="开始时间" prop="date_start">
            <el-date-picker v-model="setMethodsForm.date_start" type="date" value-format="yyyy-MM-dd"
              placeholder="选择年月日">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="date_end">
            <el-date-picker v-model="setMethodsForm.date_end" type="date" value-format="yyyy-MM-dd" placeholder="选择年月日">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否节假日" prop="is_holiday">
            <el-switch v-model="setMethodsForm.is_holiday" active-color="#b4272d" inactive-color="#6e6e6e">
            </el-switch>
          </el-form-item>
          <el-form-item label="标记颜色" prop="color">
            <div style="display: flex; align-items: center">
              <el-color-picker v-model="setMethodsForm.color" show-alpha :predefine="predefineColors">
              </el-color-picker>
            </div>
          </el-form-item>
          <el-form-item label="节假日说明标题" prop="title">
            <el-input style="width: 220px" placeholder="请输入标题" v-model="setMethodsForm.title">
            </el-input>
          </el-form-item>
          <el-form-item label="节假日说明内容" prop="description">
            <el-input style="width: 220px" type="textarea" :rows="5" placeholder="请输入内容"
              v-model="setMethodsForm.description">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button @click="dialogTableVisible = false">取消</el-button>
        <el-button type="primary" @click="saveSet">保存</el-button>
      </div>
    </el-dialog>
    <el-calendar v-model="calendarvalue">
      <template slot="dateCell" slot-scope="{ date, data }">
        <div class="showDateBoxBig">
          <div class="showDateBox" v-if="dataMatching(data.day)">
            <el-popover placement="bottom" width="400" trigger="hover">
              <div v-if="dataMatching(data.day).remark">
                <p style="font-size: 18px">
                  {{ dataMatching(data.day).remark.title }}
                </p>
                <p v-html="dataMatching(data.day).remark.description"></p>
              </div>
              <p style="text-align: center" v-else>
                {{ "暂无标语" }}
              </p>
              <div slot="reference" class="backgroundBox" :class="{ haveMethods: dataMatching(data.day).is_holiday }"
                :style="`background:${dataMatching(data.day).color
                  ? dataMatching(data.day).color : ''};color:${dataMatching(data.day).color
                    ? '#ffffff' : ''}`">
                {{ data.day.substr(8, 2) }}
              </div>
            </el-popover>
          </div>
          <div class="showDateBox" v-else>
            <div class="backgroundBox">
              {{ data.day.substr(8, 2) }}
            </div>
          </div>
          <span class="btnSpan" @click.stop="editOneDate(dataMatching(data.day), data.day)">修改</span>
        </div>
      </template>
    </el-calendar>
  </div>
</template>
<script>
import { specifiedFormatDate } from "@/utlis/date";

export default {
  data() {
    return {
      calendarvalue: specifiedFormatDate({ format: "yyyy-mm-dd" }), //日历组件的绑定值
      dialogTableVisible: false,
      calendarList: [], //有设置内容的日历列表
      rules: {
        date_start: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
        ],
        date_end: [
          { required: true, message: "请选择结束时间", trigger: "blur" },
        ],
        is_holiday: [
          { required: true, message: "请选择是否节假日", trigger: "blur" },
        ],
        // color: [{ required: true, message: "请选择标记颜色", trigger: "blur" }],
        // title: [
        //   { required: true, message: "请输入节假日说明标题", trigger: "blur" },
        // ],
        // description: [
        //   { required: true, message: "请输入节假日说明内容", trigger: "blur" },
        // ],
      },
      setMethodsForm: {
        date_start: "",
        date_end: "",
        is_holiday: false,
        color: "",
        title: "",
        description: "",
      }, //设置假期的弹窗表单
      predefineColors: [
        "#b4272d",
        "#ff8c00",
        "#ffd700",
        "#90ee90",
        "#00ced1",
        "#1e90ff",
        "#c71585",
        "rgba(255, 69, 0, 0.68)",
        "rgb(255, 120, 0)",
        "hsv(51, 100, 98)",
        "hsva(120, 40, 94, 0.5)",
        "hsl(181, 100%, 37%)",
        "hsla(209, 100%, 56%, 0.73)",
        "#c7158577",
      ],
    };
  },
  components: {},
  computed: {},
  created() {
    this.getCalendar();
  },
  watch: {
    calendarvalue: {
      handler: function (val, oldVal) {
        // 如果月份和年份改变了就重新获取页面显示月份的的事件数据
        let olddate = specifiedFormatDate({
          date: oldVal,
          format: "yyyy-mm-dd",
        });
        let newdate = specifiedFormatDate({ date: val, format: "yyyy-mm-dd" });
        // 假如年份被改变了就重新调用接口获取事件数据
        if (newdate.substr(0, 4) != olddate.substr(0, 4)) {
          console.log("年份改变");
          this.getCalendar();
        }
        // else if (newdate.substr(5, 2) != olddate.substr(5, 2)) {
        //   console.log("月份改变");
        // }
      },
    },
  },
  methods: {
    // 修改假期,v代表日期里的数据{id: 1828, date: "2023-01-02", week: 1, is_holiday: 1, color: "", remark: null},day是日期:'2023-01-02'
    editOneDate(v, day) {
      if (v) {
        let setDatas = JSON.parse(JSON.stringify(v));
        this.setMethodsForm = {
          date_start: day,
          date_end: day,
          is_holiday: !!setDatas.is_holiday, //将是否设置为假期参数转换成组件需要的格式
          color: setDatas.color || "",
          title: (setDatas.remark || {}).title,
          description: (setDatas.remark || {}).description,
        };
        // 将设置为假期并且没有设置颜色的数据里的颜色设为红色
        if (!!setDatas.is_holiday && !setDatas.color) {
          this.setMethodsForm.color = "#b4272d";
        }
      } else {
        this.setMethodsForm = {
          date_start: day,
          date_end: day,
          is_holiday: false,
          color: "",
          title: "",
          description: "",
        };
      }
      this.dialogTableVisible = true;
    },
    // 保存设置
    saveSet() {
      // 将数据转化为接口需要的格式
      let datas = JSON.parse(JSON.stringify(this.setMethodsForm));
      datas.date_start = specifiedFormatDate({
        date: datas.date_start,
        format: "yyyy-mm-dd",
      });
      datas.date_end = specifiedFormatDate({
        date: datas.date_end,
        format: "yyyy-mm-dd",
      });
      datas.remark = {
        title: datas.title,
        description: datas.description,
      };
      datas.is_holiday = datas.is_holiday ? 1 : 0;
      this.$confirm(
        `是否确认修改${datas.date_start} 到 ${datas.date_end}的假期?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$api.siteConfiguration.setCalendar(datas).then((res) => {
            ////console.log('setCalendar',res)
            if (res.code != 0) return this.$message.error(this.$fanyi(res.msg));
            //接下来的操作
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.dialogTableVisible = false;
            this.getCalendar();
          });
        })
        .catch(() => {
          //this.$message({
          //type: 'info',
          //message: '已取消删除'
          //});
        });
    },
    // 设置假期
    setMethods() {
      // 初始化数据
      this.setMethodsForm = {
        date_start: "",
        date_end: "",
        is_holiday: false,
        color: "",
        title: "",
        description: "",
      };
      this.dialogTableVisible = true;
    },
    // 从事件列表里查找出对应日期的时间数据,输入2023-01-16,输出{id: 1842, date: "2023-01-16", week: 1, is_holiday: 1, color: "", remark: null}
    dataMatching(v) {
      let data = this.calendarList.find((item) => {
        return item.date == v;
      });
      return data;
    },
    // 获取事件列表数据
    getCalendar() {
      this.$api.siteConfiguration
        .getCalendar({
          year: specifiedFormatDate({
            date: this.calendarvalue,
            format: "yyyy",
          }),
        })
        .then((res) => {
          if (res.code != 0) return this.$message.error(this.$fanyi(res.msg));
          this.calendarList = res.data;
        });
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";

.setBox {}

:deep().el-calendar__body {
  thead {
    th {
      text-align: center;
    }
  }
}

.showDateBoxBig {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  .showDateBox {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

    .backgroundBox {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
  }

  .btnSpan {
    display: none;
    color: #b4272d;
    font-size: 14px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
  }
}

.showDateBoxBig:hover {
  .btnSpan {
    display: inline;
  }
}

.backgroundBox.haveMethods {
  background-color: #b4272d;
  color: white;
}
</style>
